// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"a8605fcb","222":"a8605fcb"}[chunkId] + ".chunk.css";
};